import React, { useEffect } from "react";
import * as yup from "yup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";

import { useField } from "formik";
import { Handle } from "pages/eligibility/type";
import { QuestionProps } from "../question";
import { keyFromIdentity } from "../helpers";
import OutlinedDiv from "./outlined";

export const validator = (
  question: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
): Record<string, yup.AnySchema> => {
  const key = keyFromIdentity(question.identity, parent, index);
  const value = yup.array().ensure();
  return {
    [key]: question.required ? value.min(1, "Please check at least one.") : value,
  };
};

export const initial = (
  question: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
) => {
  const key = keyFromIdentity(question.identity, parent, index);
  return {
    [key]: [],
  };
};

type MultipleProps = {
  name: string;
}


const Checkboxes = (props: Handle<"FormQuestionMultiple"> & MultipleProps) : React.ReactElement => {
  const [field, meta, helpers] = useField(props.name);
  const options = props.data.options || [];
  // Validate on transition:
  useEffect(() => () => {
    helpers.setTouched(true);
  }, []);
  const errorClass = meta.touched && !!meta.error ? "color-hc-error" : "";
  return (
    <OutlinedDiv
      label={props.title}
      required={props.required}
      error={meta.touched && !!meta.error}
    >
      <FormGroup>
        {
          options.map(({ label, value }) => (
            <FormControlLabel
              {...field}
              control={<Checkbox className={errorClass} />}
              label={label}
              key={label}
              value={value}
              className={errorClass}
              checked={meta.value.includes(value)}
            />
          ))
        }
        {meta.touched && meta.error && (
          <FormHelperText error>
            {meta.error}
          </FormHelperText>
        )}
      </FormGroup>
    </OutlinedDiv>
  );
};

Checkboxes.initial = initial;
Checkboxes.validator = validator;
export default Checkboxes;
